import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/*
  GET /tickets/produtividade?sprints=8
  Retorna o tempo médio (em horas de desenvolvimento apontadas) que cada
  programador gasta para liberar um ticket, comparando devs entre si e
  com a média da equipe segmentada por Size (P/M/G/XG).

  Resposta esperada:
  {
    "periodo": { "sprints": 8, "versoes": ["20260601", "20260602", ...] },
    "geral": { "tickets": 80, "media_horas": 5.2, "mediana_horas": 4.0 },
    "por_size": {
      "P": { "tickets": 20, "media_horas": 1.8, "mediana_horas": 1.5 },
      "M": { "tickets": 35, "media_horas": 4.5, "mediana_horas": 4.0 },
      "G": { "tickets": 15, "media_horas": 9.2, "mediana_horas": 8.5 },
      "XG": { "tickets": 5, "media_horas": 18.0, "mediana_horas": 17.0 },
      "sem_size": { "tickets": 25, "media_horas": 3.1, "mediana_horas": 2.5 }
    },
    "devs": [
      { "desenvolvedor": "Fulano", "tickets": 14, "media_horas": 4.8, "mediana_horas": 4.0,
        "vs_equipe_pct": -7.7,
        "por_size": {
          "P": { "tickets": 4, "media_horas": 1.5, "media_equipe_horas": 1.8, "vs_equipe_pct": -16.7 },
          "M": { "tickets": 8, "media_horas": 4.2, "media_equipe_horas": 4.5, "vs_equipe_pct": -6.7 }
        }
      }, ...
    ]
  }
*/
export async function getProdutividade(sprints = 8) {
  const query = sprints === "atual" ? "atual=1" : `sprints=${sprints}`;
  const { data } = await api.get(`/tickets/produtividade?${query}`);
  return data;
}
